const names = {
	// TALLADEGA_DP: 'talladega_dp'
};

module.exports = {
	names
};
